import apiAxios from './axios'

const urlPrefix='im/m/company/'
const urlWebPrefix='im/web/company/'

/**
 * 发送职位消息
 * @returns {AxiosPromise}
 * @param userId
 * @param toUserId
 * @param jobId
 */
export function sendJobChat(userId,toUserId,jobId) {
    return apiAxios({
        url: urlPrefix+'sendJobChat',
        method: 'post',
        data: {
            userId:userId,
            toUserId:toUserId,
            jobId:jobId,
        }
    })
}

/**
 * 获取推荐求职者
 * @param jobfair_id
 * @param limit
 * @param page
 * @returns {*|AxiosPromise}
 */
export function chatNetRecommendResumes(jobfair_id,limit=15,page=1) {
    return apiAxios({
        url: urlPrefix+'chatNetRecommendResumes',
        method: 'post',
        data: {
            jobfair_id:jobfair_id,
            limit:limit,
            page:page,
        }
    })
}

/**
 * 创建洽谈申请-企业创建
 * @param jobId
 * @param userId
 * @returns {*|AxiosPromise}
 */
export function netTalkCompany(jobId,userId,jobfairId) {
    return apiAxios({
        url: urlWebPrefix+'netTalkCompany',
        method: 'post',
        data: {
            id:jobId,
            person_id:userId,
            is_mobile: 1,
            jobfair_id: jobfairId
        }
    })
}
